
import React, { Component, useState, useEffect } from 'react'
import styled from 'styled-components'
import { colors } from "theme";
import { Ptag, OverlayLoader, LargeButton } from '../components/core'
import http from '../services/httpService'
import { useNavigate, useParams } from "react-router-dom";
import * as XLSX from 'xlsx'
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import routes from "../components/routes";
import HeaderDasNew from '../components/core/headerDasNew'
import downloadcsv from '../assets/images/downloadcsv.png'
import CdCardDetail from 'components/core/Cards/CdCardDetail';
import InsurancePremium from 'components/core/Cards/InsurancePremium';
import { planName } from 'constants/businessConstant';
import SplitDetailCard from 'components/Dashboard/SplitDetailCard';
import { toLower } from 'lodash';


const PrePurchaseRecommendation = () => {
    const company_name = localStorage.getItem('company_name')
    const [loading, setLoading] = useState(false)
    const validate_emp_data = JSON.parse(localStorage.getItem('endorsment_data'))
    const navigate = useNavigate();
    const showSidebar = () => {
        return !!localStorage.getItem('id')
    }
    

    const handleSubmit = async() =>{
        
        try{
            setLoading(true)
            const userplan_id = ('userplan_id', localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id'))
            
            const {data} = await http.post("business/employee/",{
                userplan_id: userplan_id,
                input_file_data: validate_emp_data.input_file_data
            })
            localStorage.removeItem('endorsment_data')
            navigate(`/${routes.THANKYOU_PAGE}`);
        } catch(ex){
            alert(ex)
        }
    }
    const renderCards = () => {
        let planKey = Object.entries(validate_emp_data).filter(([key, value]) => typeof value == 'object').map(key => key[0])
        planKey = (planKey).sort((a, b) => {
          if (a.slice(0, 3) < b.slice(0, 3)) {
            return -1;
          } else if (a.slice(0, 3) > b.slice(0, 3)) {
            return 1;
          } else {
            return a.length < b.length ? -1 : 1;
          }
        });
        console.log(planKey)
        return (
            planKey.map( key => 
                     <>
                        <Ptag fontSize='20px' fontWeight="600" lineHeight="27px" marginTop="30px">{planName[key]}</Ptag>
                         {endorsementFile(validate_emp_data[key])}
                         <CardDiv>
                             {premiumCalculation(validate_emp_data[key])}
                             {cdAccountDetails(validate_emp_data[key])}
                         </CardDiv>
                     </>
         ))
      }

    const cdAccountDetails = (value) =>{
        return (<CdCardDetail 
            latest_transaction_date={value.latest_transaction_date} 
            shortfall={value.shortfall}
            current_cd_balance={value.current_cd_balance}
            remaining_cd_balance={value.remaining_cd_balance}
         />)
    }

    const getBoxData = (key) => {
        const number = (validate_emp_data && validate_emp_data.GMC && validate_emp_data.GMC[key]) ||
                    (validate_emp_data && validate_emp_data.GMC_M && validate_emp_data.GMC_M[key]) ||
                    (validate_emp_data && validate_emp_data.GPA && validate_emp_data.GPA[key]) ||
                    (validate_emp_data && validate_emp_data.GTL && validate_emp_data.GTL[key])
        return number || 0
    }

    const checkLength = (val, text) => {
        if(val > 1) {
            return text[0];
        } else  {
            return text[1]
        }
    }

    const endorsementFile = (total_add_delete)=> {
        const additionDetails = []
        const deletionDetails = []
        additionDetails.push({
            title: checkLength(total_add_delete['total_addition_employees'], ["EMPLOYEES", "EMPLOYEE"]),
            number: total_add_delete['total_addition_employees'] || 0
        },{
            title:checkLength(total_add_delete['total_addition_lives'], ["LIVES", "LIFE"]),
            number: total_add_delete['total_addition_lives']|| 0
        })
        deletionDetails.push({
            title: checkLength(total_add_delete['total_deletion_employees'], ["EMPLOYEES", "EMPLOYEE"]),
            number: total_add_delete['total_deletion_employees'] || 0
        },{
            title: checkLength(total_add_delete['total_deletion_lives'], ["LIVES", "LIFE"]),
            number: total_add_delete['total_deletion_lives'] || 0
        })
        return(
            <TotalNumberDiv>
                <SplitDetailCard title="Total Addition" details={additionDetails}/>
                <SplitDetailCard title="Total Deletion" details={deletionDetails}/>
            </TotalNumberDiv>
        )
    }

    const premiumCalculation = (value) =>{
        return (
            <InsurancePremium 
                sum_premium_due={value.sum_premium_due} 
                sum_refunds={value.sum_refunds}
                net_premium_and_refunds={value.net_premium_and_refunds}
            />
         )
    }

    const wellnessTextField = () =>{
        return(
            <FlexRowDivWellness>
                {
                    (validate_emp_data && !!getBoxData('wellness_fee_average'))?
                    <WellnessBox>
                        <Ptag fontSize="24px" fontWeight="600" color="#4A4A4A" lineHeight="32px" letterSpacing="0.5px" marginTop='20px' marginBottom='15px'>Wellness Fees</Ptag>
                        <Ptag marginBottom='10px' fontSize="16px">
                            Your plan comes with <BoldTag>{getBoxData('wellness_sentence')}</BoldTag>. The wellness fees is in addition to your insurance premium and payable separately, upon the generation of policy numbers. Payment button for the same will become visible on your dashboard.
                        </Ptag>
                            <div>
                            <Text2><BoldTag>Wellness fee: Rs.{(getBoxData('wellness_sentence')) || 0} per annum per employee,</BoldTag>calculated pro-data basis the policy start date.</Text2>
                            </div>
                    </WellnessBox>:
                    <WellnessBox>
                        <Ptag fontSize="24px" fontWeight="600" color="#4A4A4A" lineHeight="32px" letterSpacing="0.5px" marginBottom='15px' marginTop='30px'>Wellness Fees</Ptag>
                        <Ptag marginBottom='10px' fontSize="16px">
                            Your plan comes with a suite of wellness benefits that include <BoldTag>{validate_emp_data && getBoxData('wellness_sentence')}</BoldTag>.<Text2>This is <BoldTag>complimentary with your plan.</BoldTag></Text2>
                        </Ptag>
                    </WellnessBox>
                }
            </FlexRowDivWellness>
        )
    }
    const generateTableData = () => {
        const reducer = (acc, value, index) => {
            const empData = validate_emp_data[value].input_file_data;
            const newTableData = acc;
            var lowerCase = toLower(`employee_${value}_sum_insured`)
            if(!empData){
                return newTableData
            }
            empData.forEach(employee => {
                const empIdx = acc.findIndex((prevEmp) => prevEmp.phone === employee.employee_phone);
                if(empIdx > -1) {
                    newTableData[empIdx][value] = {
                            start_date : employee.start_date,
                            policy_end_date:employee.policy_end_date,
                            sum_insured : employee[lowerCase] || 0,
                            premium_due : employee.premium_due,
                            premium_paid : employee.premium_paid,
                            refund_due : employee.refund_due,
                            remarks: employee.remarks
                    }
                } else {
                    const obj = {
                        name: employee.employee_first_name,
                        last_name : employee.employee_last_name,
                        gender: employee.employee_gender,
                        dob: employee.employee_dob,
                        phone : employee.employee_phone,
                        mail : employee.employee_email,
                        dependent : employee.employee_dependents,
                        endorsement_type : employee.employee_endorsement_type,
                        uhid:employee.employee_UHID ,
                        [value]: {
                            start_date : employee.start_date,
                            policy_end_date:employee.policy_end_date,
                            sum_insured : employee[lowerCase],
                            premium_due : employee.premium_due,
                            premium_paid : employee.premium_paid,
                            refund_due : employee.refund_due,
                            remarks: employee.remarks
                        }
                    }
                    newTableData.push(obj);
                }
            })
            return newTableData;
        }
        return Object.keys(validate_emp_data).reduce(reducer, []);
    }
    const xport = React.useCallback(async () => {
        const { data } = await http.post("business/download_endorsement_data/", validate_emp_data, { responseType: 'blob' })
        
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = 'endorsement_preview.xlsx';

        // Append link to the DOM and click it
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        // const table = document.getElementById("Table2XLSX");
        // const wb = XLSX.utils.table_to_book(table);
        // XLSX.writeFile(wb, "Endorsment.xlsx");
      });

    function DownloadExcel(props) {
        const numbers = Array.from({ length: 5 }, (_, i) => i + 1);
        const newObj = generateTableData()
        const showGmcColumn = newObj[0].hasOwnProperty("GMC")
        const showGmcmColumn =  newObj[0].hasOwnProperty("GMC_M");
        const showGpaColumn = newObj[0].hasOwnProperty("GPA");
        const showGtlColumn = newObj[0].hasOwnProperty("GTL");
        const generateDependentData = (dependents) => {
            const totalDependents = dependents.length;
            const emptyIterations = Array(7 - totalDependents).fill(0);
           
            return (
                <>
                {
                    dependents.map((dependent) => (
                        <>
                            <td>{dependent?.dep_type}</td>
                            <td>{dependent?.dep_first_name}</td>
                            <td>{dependent?.dep_last_name}</td>
                            <td>{dependent?.dep_dob}</td>
                        </>
                    ))
                }
                {
                    emptyIterations.map((_) => (
                        <>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                        </>
                    ))
                }
                </>
            )
            
        }
        const generateDependentsHeaders = () => {
            return numbers.map(_ => (
                <>
                    <th>Dependent Type</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>DOB</th>
                </>
            ))
        }
        return (
        <div style={{display: "none"}}>
          <table  id="Table2XLSX">
            <tbody>
                <tr>
                    <td colSpan="8"/>
                    {numbers.map(num => (
                                <th colSpan="4">Dependent {num}</th>
                            ))}
                    {showGmcColumn && (
                        <td colSpan={7}>GMC</td>
                    )}
                    {showGmcmColumn && (
                        <td colSpan={7}>GMC</td>
                    )}
                    {showGpaColumn && (
                        <td colSpan={7}>GPA</td>
                    )}
                    {showGtlColumn && (
                        <td colSpan={7}>GTL</td>
                    )}
                </tr>
                <tr>
                        <td>First Name</td>
                        <td>Last Name</td>
                        <td>Gender</td>
                        <td>DOB</td>
                        <td>Phone</td>
                        <td>Mail</td>
                        <td>UHID</td>
                        <td>Endorsement Type</td>
                        {generateDependentsHeaders()}
                        {showGmcColumn && (
                            <>
                                <td>Start Date</td>
                                <td>End Date</td>
                                <td>Sum Insured</td>
                                <td>Premium Due</td>
                                <td>Premium Paid</td>
                                <td>Refund Due</td>
                                <td>Remarks</td>
                            </>
                        )}
                         {showGmcmColumn && (
                            <>
                                <td>Start Date</td>
                                <td>End Date</td>
                                <td>Sum Insured</td>
                                <td>Premium Due</td>
                                <td>Premium Paid</td>
                                <td>Refund Due</td>
                                <td>Remarks</td>
                            </>
                        )}
                        {showGpaColumn && (
                            <>
                                <td>Start Date</td>
                                <td>End Date</td>
                                <td>Sum Insured</td>
                                <td>Premium Due</td>
                                <td>Premium Paid</td>
                                <td>Refund Due</td>
                                <td>Remarks</td>
                            </>
                        )}
                        {showGtlColumn && (
                            <>
                                <td>Start Date</td>
                                <td>End Date</td>
                                <td>Sum Insured</td>
                                <td>Premium Due</td>
                                <td>Premium Paid</td>
                                <td>Refund Due</td>
                                <td>Remarks</td>
                            </>
                        )}
                </tr>
                {newObj.map((emp, i) => (
                    <tr>
                        <td>{emp.name}</td>
                        <td>{emp.last_name}</td>
                        <td>{emp.gender}</td>
                        <td>{emp.dob}</td>
                        <td>{emp.phone}</td>
                        <td>{emp.mail}</td>
                        <td>{emp.uhid}</td>
                        <td>{emp.endorsement_type}</td>
                        {generateDependentData(emp.dependent)}
                        {showGmcColumn && (
                            <>
                                <td>{emp.GMC.start_date}</td>
                                <td>{emp.GMC.policy_end_date}</td>
                                <td>{emp.GMC.sum_insured}</td>
                                <td>{emp.GMC.premium_due}</td>
                                <td>{emp.GMC.premium_paid}</td>
                                <td>{emp.GMC.refund_due}</td>
                                <td>{emp.GMC.remarks}</td>
                            </>
                        )}
                        {showGmcmColumn && (
                            <>
                                <td>{emp.GMC_M.start_date}</td>
                                <td>{emp.GMC_M.policy_end_date}</td>
                                <td>{emp.GMC_M.sum_insured}</td>
                                <td>{emp.GMC_M.premium_due}</td>
                                <td>{emp.GMC_M.premium_paid}</td>
                                <td>{emp.GMC_M.refund_due}</td>
                                <td>{emp.GMC_M.remarks}</td>
                            </>
                        )}
                        {showGpaColumn && (
                            <>
                                <td>{emp.GPA.start_date}</td>
                                <td>{emp.GPA.policy_end_date}</td>
                                <td>{emp.GPA.sum_insured}</td>
                                <td>{emp.GPA.premium_due}</td>
                                <td>{emp.GPA.premium_paid}</td>
                                <td>{emp.GPA.refund_due}</td>
                                <td>{emp.GPA.remarks}</td>
                            </>
                        )}
                        {showGtlColumn && (
                            <>
                                <td>{emp.GTL.start_date}</td>
                                <td>{emp.GTL.policy_end_date}</td>
                                <td>{emp.GTL.sum_insured}</td>
                                <td>{emp.GTL.premium_due}</td>
                                <td>{emp.GTL.premium_paid}</td>
                                <td>{emp.GTL.refund_due}</td>
                                <td>{emp.GTL.remarks}</td>
                            </>
                        )}
                    </tr>
                ))}
            </tbody></table>
          <button onClick={xport}><b>Export XLSX!</b></button>
        </div>
        );
      }


    const premiumEstimate = () => {
        return(
            <PremiumEstimateMainDiv>
                <FlexRowDiv2>
                        <InnerTextDiv>
                            <Ptag fontSize='24px' fontWeight='700' marginBottom='16px'>Insurance Premium - Estimate</Ptag>
                            <Ptag fontSize='14px'>The figures shown below are estimated values, and may change upon the final quote shared by the insurer.</Ptag>
                        </InnerTextDiv>
                        <DownloadExcelTag>
                            <Ptag fontSize='14px' fontweight='550'>Employee-wise Breakup</Ptag>
                            <CommonBox>
                                <Download onClick={xport}>
                                    <img src={downloadcsv} width='20px' height='20px' style={{ marginRight: 10 }} />
                                    <Ptag fontSize="13px" fontWeight="600" color="#FFFFFF" lineHeight="24px" letterSpacing="0.5px">Download Excel</Ptag>
                                </Download>
                            </CommonBox>
                        </DownloadExcelTag>
                </FlexRowDiv2>
                <div style={{paddingTop: '12px'}}>
                    {renderCards()}
                </div>
                <YellowBoxNote>
                    <YellowFlexBox>
                        <Ptag fontSize='18px' fontweight='600'>Note</Ptag>
                        <Ptag>Please ensure your CD Balance is adequate. That will ensure seamless endorsements and policy generation. We recommend you keep an additional 10% amount in the CD account to avoid last-minute hassles in additions/deletions.</Ptag>
                    </YellowFlexBox>
                </YellowBoxNote>
            </PremiumEstimateMainDiv>
        )
    }

    return (
        <>
            <SideNav>
                {
                    showSidebar() && 
                    <SideNavContent />
                }
                
            </SideNav>
            <HeaderDasNew company_name={company_name} />
            <HomeWrapper>
                <OuterDiv>
                    <TextUpper>Thank You!</TextUpper>
                    <ThankYouText>
                        The endorsement file has been shared with the insurer. 
                    </ThankYouText>
                </OuterDiv>
                {premiumEstimate()}
                {/* {!!getBoxData('wellness_sentence') && wellnessTextField()} */}
                {DownloadExcel()}
            </HomeWrapper>
        </>
    )
}
// }

const ThankYouText = styled.p`
  margin: 0px 18% 5% 12%;
  padding: 10px 40px 40px 40px;
  text-align: center;
  font-family: 'Inter';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  background-color: #FDF6E9;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`
const OuterDiv = styled.div`
    justify-content: center;
    border-bottom: 20px solid ;
    border-color: #f2f0f0;
    position: relative;
    width: calc(100% + 160px);
    left: -28px;
`

const TextUpper = styled.p`
  margin: 0px 18% 0px 12%;
  padding-top: 30px;
  font-family: 'Inter';
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  background-color: #FDF6E9;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`
const CardDiv = styled.div`
    display: flex;
    gap: 2rem;
`
const Text2 = styled.p`
    font-weight: 400;
    font-size: 16px;
    color: #4a4a4a;
`
const BoldTag = styled.b`
    font-weight: 600;
`

const YellowFlexBox = styled.div`
    display: flex;
    flex-direction: column;
`
const WellnessBox = styled.div`
    margin: 20px;
    margin-top: 0px;
    border-top: 1px solid #000000;
    min-width: 96%;
`
const YellowBoxNote = styled.div`
    min-width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #FDBD0C75;
    border-radius: 10px;
    padding: 20px;
`

const DownloadExcelTag = styled.div`
    display: flex;
    flex-direction:column;
    margin-left: 20px;
`

const CommonBox = styled.div`
    display:flex;
`

const Download = styled.div`
    margin-top: 7px;
    border: 0px;
    color: rgb(255, 255, 255);
    background: ${colors.accentColor};
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    letter-spacing: 0.5px;
    font-size: 13px;
    cursor: pointer;
    letter-spacing: 0.5px;
    border: 1px solid #F7F9FD;
    border-radius: 10px;
    /* margin-right:10px; */

`

const PremiumEstimateMainDiv = styled.div`
    padding: 40px 20px 20px 20px;
    display: flex;
    flex-direction: column;
`
const FlexRowDiv2 = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
const FlexRowDivWellness = styled.div`
    display: flex;
    flex-direction: row;
    min-width: 100%;
`

const InnerTextDiv = styled.div`
    max-width: 70%;
`
const TotalNumberDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap:1rem;
    margin-top: 20px;
`

const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  margin-left: 200px;
`
export default PrePurchaseRecommendation